<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <pr-input label="Durée du credit" suffix="mois" [derrors]="derrors">
    <input formControlName="durationInMonth" type="text" />
  </pr-input>

  <pr-input label="Taux du crédit" suffix="%" [derrors]="derrors">
    <input formControlName="rate" type="text" />
  </pr-input>

  <pr-input label="Taux de l'assurance" suffix="%" [derrors]="derrors">
    <input formControlName="insuranceRate" type="text" />
  </pr-input>

  <pr-input label="Rendement locatif" suffix="%" [derrors]="derrors">
    <input formControlName="rapportLocatif" type="text" />
  </pr-input>
</pr-form>
